import * as Types from '../../../../__generated__/schema';

import {
  ActorTeaserAPIToken,
  ActorTeaserUser,
} from '../../../graphql/fragments/ActorTeaser.generated';
import { GraphQLError } from 'graphql';
import { gql } from '@apollo/client';
import { ActorTeaser } from '../../../graphql/fragments/ActorTeaser.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RunAISummarizeAlertVariables = Types.Exact<{
  input: Types.AISummarizeAlertInput;
}>;

export type RunAISummarizeAlert = {
  aiSummarizeAlert: Pick<
    Types.AIInferenceStream,
    'streamName' | 'streamId' | 'pinned' | 'private' | 'saved' | 'createdAt' | 'parentStreamId'
  > & { createdBy?: Types.Maybe<ActorTeaserAPIToken | ActorTeaserUser> };
};

export const RunAISummarizeAlertDocument = gql`
  mutation RunAISummarizeAlert($input: AISummarizeAlertInput!) {
    aiSummarizeAlert(input: $input) {
      streamName
      streamId
      pinned
      private
      saved
      createdBy {
        ...ActorTeaser
      }
      createdAt
      parentStreamId
    }
  }
  ${ActorTeaser}
`;
export type RunAISummarizeAlertMutationFn = Apollo.MutationFunction<
  RunAISummarizeAlert,
  RunAISummarizeAlertVariables
>;

/**
 * __useRunAISummarizeAlert__
 *
 * To run a mutation, you first call `useRunAISummarizeAlert` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRunAISummarizeAlert` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [runAiSummarizeAlert, { data, loading, error }] = useRunAISummarizeAlert({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useRunAISummarizeAlert(
  baseOptions?: Apollo.MutationHookOptions<RunAISummarizeAlert, RunAISummarizeAlertVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<RunAISummarizeAlert, RunAISummarizeAlertVariables>(
    RunAISummarizeAlertDocument,
    options,
  );
}
export type RunAISummarizeAlertHookResult = ReturnType<typeof useRunAISummarizeAlert>;
export type RunAISummarizeAlertMutationResult = Apollo.MutationResult<RunAISummarizeAlert>;
export type RunAISummarizeAlertMutationOptions = Apollo.BaseMutationOptions<
  RunAISummarizeAlert,
  RunAISummarizeAlertVariables
>;
export function mockRunAISummarizeAlert({
  data,
  variables,
  errors,
}: {
  data: RunAISummarizeAlert;
  variables?: RunAISummarizeAlertVariables;
  errors?: GraphQLError[];
}) {
  return {
    request: { query: RunAISummarizeAlertDocument, variables },
    result: { data, errors },
  };
}
